"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[643],{

/***/ 66806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ EnhancedLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);






var EnhancedLink = function(_param) {
    var href = _param.href, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "href",
        "children"
    ]);
    var isExternal = href.startsWith("http");
    var InnerLink = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        as: "a",
        target: isExternal ? "_blank" : undefined,
        href: isExternal ? href : undefined
    }, props), {
        children: children
    }));
    return isExternal ? InnerLink : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        passHref: true,
        children: InnerLink
    });
};


/***/ }),

/***/ 31046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ HTMLText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48641);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25935);
/* harmony import */ var _EnhancedLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66806);








var parserOptions = {
    replace: function(domNode) {
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(domNode, html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* .Element */ .W_)) {
            if (domNode.name === "a") {
                var attribs = (0,html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* .attributesToProps */ .e_)(domNode.attribs);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_EnhancedLink__WEBPACK_IMPORTED_MODULE_2__/* .EnhancedLink */ .g, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    href: attribs.href
                }, attribs), {
                    children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* .domToReact */ .du)(domNode.children, parserOptions)
                }));
            }
        }
    }
};
var HTMLText = function(_param) {
    var text = _param.text, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "text"
    ]);
    var parsedHtml = (0,html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(text, parserOptions);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        __css: {
            p: {
                mb: 4
            },
            "ol, ul": {
                ml: 5
            },
            a: {
                textDecoration: "underline"
            }
        }
    }, props), {
        children: parsedHtml
    }));
};


/***/ }),

/***/ 21097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23887);





var Image = function(_param) {
    var imageStyle = _param.imageStyle, image = _param.image, hideCopyright = _param.hideCopyright, wrapperProps = _param.wrapperProps, description = _param.description, copyrightInside = _param.copyrightInside, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "imageStyle",
        "image",
        "hideCopyright",
        "wrapperProps",
        "description",
        "copyrightInside"
    ]);
    if (!imageStyle) return null;
    var showCopyright = !hideCopyright && image.copyright;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        className: "image-".concat(image.id),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                pos: "relative"
            }, wrapperProps), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Img */ .Ei, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                        htmlWidth: imageStyle.width,
                        htmlHeight: imageStyle.height,
                        src: imageStyle.url,
                        width: "100%",
                        loading: "lazy",
                        alt: image.alt || ""
                    }, props)),
                    showCopyright && copyrightInside && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                        pos: "absolute",
                        left: 0,
                        bottom: 0,
                        bg: "rgba(0,0,0, .4)",
                        color: "white",
                        p: 1,
                        fontSize: "xxs",
                        children: [
                            "Foto \xa9 ",
                            image.copyright
                        ]
                    })
                ]
            })),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                pt: 1,
                fontSize: "md",
                children: description
            }),
            showCopyright && !copyrightInside && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                fontSize: "xxs",
                children: [
                    "Foto \xa9 ",
                    image.copyright
                ]
            })
        ]
    });
};


/***/ }),

/***/ 45893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ TabSearch; }
/* harmony export */ });
/* unused harmony export TabSearchTab */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94199);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53749);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _LocationSearch__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35962);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40353);
/* harmony import */ var _utils_filters__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97126);








var TabItem = function(param) {
    var label = param.label, isActive = param.isActive;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Tab */ .OK, {
        py: 3,
        px: {
            base: 3,
            md: 6
        },
        bg: isActive ? "white" : "rgba(255,255,255, .6)",
        color: {
            base: isActive ? "primary" : "gray.500",
            md: "primary"
        },
        borderTopRadius: "sm",
        border: "none",
        fontWeight: "bold",
        mr: 2,
        _hover: {
            bg: "white"
        },
        _selected: {
            color: "primary"
        },
        whiteSpace: "nowrap",
        children: label
    });
};
var TabSearchTab = function(param) {
    var tab = param.tab, searchValue = param.searchValue, setSearchValue = param.setSearchValue;
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var pageContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context_PageContext__WEBPACK_IMPORTED_MODULE_5__/* .PageContext */ .z);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([
        "".concat(((ref = tab.subCategories) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.id) || 0), 
    ]), activeSubCategoryIds = ref2[0], setActiveSubcategoryIds = ref2[1];
    var searchPath = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var ref, ref1, ref2;
        return ((ref = tab.searchPageLink) === null || ref === void 0 ? void 0 : ref.url) || ((ref1 = pageContext.config) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.mainSearchPage) === null || ref2 === void 0 ? void 0 : ref2.url) || "";
    }, [
        tab
    ]);
    var pathParams = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (activeSubCategoryIds.length) {
            return {
                filters: (0,_utils_filters__WEBPACK_IMPORTED_MODULE_6__/* .filtersToQuery */ .KV)([
                    {
                        conditions: [
                            {
                                field: "sub_categories",
                                operator: "IN",
                                value: activeSubCategoryIds.join(",")
                            }, 
                        ]
                    }, 
                ])
            };
        }
        return null;
    }, [
        activeSubCategoryIds
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .kC, {
        alignItems: {
            base: "flex-start",
            md: "center"
        },
        justifyContent: "space-between",
        flexDirection: {
            base: "column",
            md: "row"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .CheckboxGroup */ .cO, {
                onChange: function(value) {
                    setActiveSubcategoryIds(value);
                },
                value: activeSubCategoryIds,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Stack */ .Kq, {
                    direction: {
                        base: "column",
                        md: "row"
                    },
                    spacing: 4,
                    children: tab.subCategories.map(function(subCategory, j) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Checkbox */ .XZ, {
                            value: "".concat(subCategory.id),
                            children: subCategory.title
                        }, subCategory.id);
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                mt: {
                    base: 4,
                    md: 0
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LocationSearch__WEBPACK_IMPORTED_MODULE_3__/* .LocationSearch */ .U, {
                    value: searchValue,
                    onInputChange: function(e) {
                        setSearchValue(e.target.value);
                    },
                    onSubmit: function() {},
                    allowEmptySubmit: true,
                    submitPath: searchPath,
                    pathParams: pathParams
                })
            })
        ]
    });
};
var TabSearch = function(param) {
    var tabs = param.tabs;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), index = ref[0], setIndex = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), searchValue = ref1[0], setSearchValue = ref1[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
        color: "primary",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                mx: 4,
                mb: 8,
                display: {
                    base: "block",
                    md: "none"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                        fontFamily: "heading",
                        textAlign: "center",
                        mb: 4,
                        fontSize: "xl",
                        fontWeight: "bold",
                        children: "Anbieter finden"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Stack */ .Kq, {
                        direction: "column",
                        children: tabs.map(function(tab) {
                            var ref;
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                href: ((ref = tab.searchPageLink) === null || ref === void 0 ? void 0 : ref.url) || "/",
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .kC, {
                                    alignItems: "center",
                                    as: "a",
                                    bg: "primary",
                                    color: "white",
                                    py: 2,
                                    px: 3,
                                    borderRadius: "full",
                                    fontWeight: "bold",
                                    children: [
                                        tab.category.icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: tab.category.icon.url,
                                            width: 30
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                                            ml: 2,
                                            children: tab.category.title
                                        })
                                    ]
                                })
                            }, "mobile-".concat(tab.id));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Tabs */ .mQ, {
                display: {
                    base: "none",
                    md: "block"
                },
                index: index,
                onChange: setIndex,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .TabList */ .td, {
                        borderBottom: "none",
                        overflowX: {
                            base: "auto",
                            md: "hidden"
                        },
                        overflowY: "hidden",
                        children: tabs.map(function(tab, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TabItem, {
                                label: tab.category.title,
                                isActive: index === i
                            }, tab.id);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .TabPanels */ .nP, {
                        children: tabs.map(function(tab, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .TabPanel */ .x4, {
                                py: 4,
                                px: 6,
                                bg: "white",
                                borderRadius: "sm",
                                borderTopLeftRadius: "none",
                                shadow: {
                                    base: "none",
                                    md: "lg"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TabSearchTab, {
                                    tab: tab,
                                    searchValue: searchValue,
                                    setSearchValue: setSearchValue
                                })
                            }, tab.id);
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 10643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Hero": function() { return /* reexport */ Hero; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/image/dist/index.esm.js
var dist_index_esm = __webpack_require__(23887);
// EXTERNAL MODULE: ./src/components/Common/Image.tsx
var Image = __webpack_require__(21097);
// EXTERNAL MODULE: ./src/components/Common/HTMLText.tsx
var HTMLText = __webpack_require__(31046);
// EXTERNAL MODULE: ./src/components/Common/TabSearch.tsx
var TabSearch = __webpack_require__(45893);
;// CONCATENATED MODULE: ./src/components/Paragraph/Hero/Hero.tsx





var Hero = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        pos: "relative",
        my: -6,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                pos: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                        maxH: "665px",
                        objectFit: "cover",
                        imageStyle: data.image.imageStyle,
                        image: data.image,
                        loading: "eager",
                        hideCopyright: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Img */.Ei, {
                        src: "/header_wave.svg",
                        width: "100%",
                        pos: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                pos: "absolute",
                left: 0,
                right: 0,
                bottom: 0,
                top: 0,
                zIndex: 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                    color: "#fff",
                    maxW: "container.main",
                    zIndex: 1,
                    pt: {
                        base: 4,
                        md: 20
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HTMLText/* HTMLText */.J, {
                            text: data.text
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            display: {
                                base: "none",
                                md: "block"
                            },
                            children: data.searchBar && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                mt: 20,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabSearch/* TabSearch */.W, {
                                    tabs: data.searchBar.searchCategories
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                pos: "relative",
                zIndex: 1,
                display: {
                    base: "block",
                    md: "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
                    color: "#fff",
                    maxW: "container.main",
                    zIndex: 1,
                    px: 0,
                    pt: {
                        base: 4,
                        md: 20
                    },
                    children: data.searchBar && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabSearch/* TabSearch */.W, {
                        tabs: data.searchBar.searchCategories
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Paragraph/Hero/index.ts



/***/ })

}]);